import { render, staticRenderFns } from "./DialogMFullPage.vue?vue&type=template&id=1bcf57d6&scoped=true&"
import script from "./DialogMFullPage.vue?vue&type=script&lang=js&"
export * from "./DialogMFullPage.vue?vue&type=script&lang=js&"
import style0 from "./DialogMFullPage.vue?vue&type=style&index=0&id=1bcf57d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf57d6",
  null
  
)

export default component.exports